import { render, staticRenderFns } from "./UserActivityDialog.vue?vue&type=template&id=329a8374&scoped=true"
import script from "./UserActivityDialog.vue?vue&type=script&lang=js"
export * from "./UserActivityDialog.vue?vue&type=script&lang=js"
import style0 from "./UserActivityDialog.vue?vue&type=style&index=0&id=329a8374&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a8374",
  null
  
)

export default component.exports